<div class="cont">
  <div class="screen">
    <div class="keyGroup">
      <input
        id="textScreen"
        class="textScreen"
        #keyValue
        [(ngModel)]="elementValue"
        [type]="data.type == 'password' ? 'password' : 'text'"
      />
    </div>
    <div class="keyGroup">
      <button
        class="regularKey"
        (click)="addChar(keyboard.actualKeys['accent'])"
      >
        {{ keyboard.actualKeys["accent"] }}
      </button>
      <button class="regularKey" (click)="addChar(keyboard.actualKeys['1'])">
        {{ keyboard.actualKeys["1"] }}
      </button>
      <button class="regularKey" (click)="addChar(keyboard.actualKeys['2'])">
        {{ keyboard.actualKeys["2"] }}
      </button>
      <button class="regularKey" (click)="addChar(keyboard.actualKeys['3'])">
        {{ keyboard.actualKeys["3"] }}
      </button>
      <button class="regularKey" (click)="addChar(keyboard.actualKeys['4'])">
        {{ keyboard.actualKeys["4"] }}
      </button>
      <button class="regularKey" (click)="addChar(keyboard.actualKeys['5'])">
        {{ keyboard.actualKeys["5"] }}
      </button>
      <button class="regularKey" (click)="addChar(keyboard.actualKeys['6'])">
        {{ keyboard.actualKeys["6"] }}
      </button>
      <button class="regularKey" (click)="addChar(keyboard.actualKeys['7'])">
        {{ keyboard.actualKeys["7"] }}
      </button>
      <button class="regularKey" (click)="addChar(keyboard.actualKeys['8'])">
        {{ keyboard.actualKeys["8"] }}
      </button>
      <button class="regularKey" (click)="addChar(keyboard.actualKeys['9'])">
        {{ keyboard.actualKeys["9"] }}
      </button>
      <button class="regularKey" (click)="addChar(keyboard.actualKeys['0'])">
        {{ keyboard.actualKeys["0"] }}
      </button>
      <button
        class="regularKey"
        (click)="addChar(keyboard.actualKeys['hyphen'])"
      >
        {{ keyboard.actualKeys["hyphen"] }}
      </button>
      <button
        class="regularKey"
        (click)="addChar(keyboard.actualKeys['equal'])"
      >
        {{ keyboard.actualKeys["equal"] }}
      </button>
      <button class="x2Key" (click)="backspace()">&#x2190;</button>
    </div>
    <div class="keyGroup">
      <button class="x2Key" (click)="('  ')">->|</button>
      <button class="regularKey" (click)="addChar(keyboard.actualKeys['q'])">
        {{ keyboard.actualKeys["q"] }}
      </button>
      <button class="regularKey" (click)="addChar(keyboard.actualKeys['w'])">
        {{ keyboard.actualKeys["w"] }}
      </button>
      <button class="regularKey" (click)="addChar(keyboard.actualKeys['e'])">
        {{ keyboard.actualKeys["e"] }}
      </button>
      <button class="regularKey" (click)="addChar(keyboard.actualKeys['r'])">
        {{ keyboard.actualKeys["r"] }}
      </button>
      <button class="regularKey" (click)="addChar(keyboard.actualKeys['t'])">
        {{ keyboard.actualKeys["t"] }}
      </button>
      <button class="regularKey" (click)="addChar(keyboard.actualKeys['y'])">
        {{ keyboard.actualKeys["y"] }}
      </button>
      <button class="regularKey" (click)="addChar(keyboard.actualKeys['u'])">
        {{ keyboard.actualKeys["u"] }}
      </button>
      <button class="regularKey" (click)="addChar(keyboard.actualKeys['i'])">
        {{ keyboard.actualKeys["i"] }}
      </button>
      <button class="regularKey" (click)="addChar(keyboard.actualKeys['o'])">
        {{ keyboard.actualKeys["o"] }}
      </button>
      <button class="regularKey" (click)="addChar(keyboard.actualKeys['p'])">
        {{ keyboard.actualKeys["p"] }}
      </button>
      <button class="regularKey" (click)="addChar(keyboard.actualKeys['keyL'])">
        {{ keyboard.actualKeys["keyL"] }}
      </button>
      <button class="regularKey" (click)="addChar(keyboard.actualKeys['keyR'])">
        {{ keyboard.actualKeys["keyR"] }}
      </button>
      <button
        class="regularKey"
        (click)="addChar(keyboard.actualKeys['backslash'])"
      >
        {{ keyboard.actualKeys["backslash"] }}
      </button>
    </div>
    <div class="keyGroup">
      <button class="xHKey" (click)="onMayus()">Caps</button>
      <button class="regularKey" (click)="addChar(keyboard.actualKeys['a'])">
        {{ keyboard.actualKeys["a"] }}
      </button>
      <button class="regularKey" (click)="addChar(keyboard.actualKeys['s'])">
        {{ keyboard.actualKeys["s"] }}
      </button>
      <button class="regularKey" (click)="addChar(keyboard.actualKeys['d'])">
        {{ keyboard.actualKeys["d"] }}
      </button>
      <button class="regularKey" (click)="addChar(keyboard.actualKeys['f'])">
        {{ keyboard.actualKeys["f"] }}
      </button>
      <button class="regularKey" (click)="addChar(keyboard.actualKeys['g'])">
        {{ keyboard.actualKeys["g"] }}
      </button>
      <button class="regularKey" (click)="addChar(keyboard.actualKeys['h'])">
        {{ keyboard.actualKeys["h"] }}
      </button>
      <button class="regularKey" (click)="addChar(keyboard.actualKeys['j'])">
        {{ keyboard.actualKeys["j"] }}
      </button>
      <button class="regularKey" (click)="addChar(keyboard.actualKeys['k'])">
        {{ keyboard.actualKeys["k"] }}
      </button>
      <button class="regularKey" (click)="addChar(keyboard.actualKeys['l'])">
        {{ keyboard.actualKeys["l"] }}
      </button>
      <button class="regularKey" (click)="addChar(keyboard.actualKeys['p'])">
        {{ keyboard.actualKeys["p"] }}
      </button>
      <button
        class="regularKey"
        (click)="addChar(keyboard.actualKeys['dot-comma'])"
      >
        {{ keyboard.actualKeys["dot-comma"] }}
      </button>
      <button
        class="regularKey"
        (click)="addChar(keyboard.actualKeys['cometa-simple'])"
      >
        {{ keyboard.actualKeys["cometa-simple"] }}
      </button>
      <button class="xHKey" (click)="onEnterClick()">Intro</button>
    </div>
    <div class="keyGroup">
      <button class="x2Key" (click)="onShift()">Shift</button>
      <button class="regularKey" (click)="addChar(keyboard.actualKeys['z'])">
        {{ keyboard.actualKeys["z"] }}
      </button>
      <button class="regularKey" (click)="addChar(keyboard.actualKeys['x'])">
        {{ keyboard.actualKeys["x"] }}
      </button>
      <button class="regularKey" (click)="addChar(keyboard.actualKeys['c'])">
        {{ keyboard.actualKeys["c"] }}
      </button>
      <button class="regularKey" (click)="addChar(keyboard.actualKeys['v'])">
        {{ keyboard.actualKeys["v"] }}
      </button>
      <button class="regularKey" (click)="addChar(keyboard.actualKeys['b'])">
        {{ keyboard.actualKeys["b"] }}
      </button>
      <button class="regularKey" (click)="addChar(keyboard.actualKeys['n'])">
        {{ keyboard.actualKeys["n"] }}
      </button>
      <button class="regularKey" (click)="addChar(keyboard.actualKeys['m'])">
        {{ keyboard.actualKeys["m"] }}
      </button>
      <button
        class="regularKey"
        (click)="addChar(keyboard.actualKeys['comma'])"
      >
        {{ keyboard.actualKeys["comma"] }}
      </button>
      <button class="regularKey" (click)="addChar(keyboard.actualKeys['dot'])">
        {{ keyboard.actualKeys["dot"] }}
      </button>
      <button class="regularKey" (click)="addChar(keyboard.actualKeys['bar'])">
        {{ keyboard.actualKeys["bar"] }}
      </button>
      <button class="x3Key" (click)="onShift()">Shift</button>
    </div>
    <div class="keyGroup">
      <button class="space" (click)="addChar(' ')"></button>
    </div>
  </div>
</div>
